<template>
    <div id="MainContent">
        <h1>Contacts</h1>
        
        <!-- All Users -->
        <div v-if="!id">
            <button @click="showCreate = !showCreate">{{showCreate ? 'Hide':'Show'}} Create</button>
            <OrganizationCreate v-show="showCreate" />
            <OrganizationList />
        </div>
        
        <!-- Single User -->
        <OrganizationDetail v-if="id"></OrganizationDetail>
    </div>
</template>

<script>
    // Import Helpers
    import {EnsureUserLoggedin} from '../Utilities.js'
    import OrganizationList from '../components/OrganizationList'
    import OrganizationCreate from '../components/OrganizationCreate'
    import OrganizationDetail from '../components/OrganizationDetail'

    // Module Code
    export default {
        props: ['id'],
        
        beforeRouteEnter: EnsureUserLoggedin,
        data: function() {
            return {showCreate: false}
        },
        components: {
            OrganizationList, OrganizationCreate, OrganizationDetail
        },
    }
</script>